import type { RouteRecordRaw } from "vue-router";

export enum ContabilPortalComunicaoRouter {
  base = "index"
}

export const comunicacaoRoutes: Array<RouteRecordRaw> = [
  {
    path: "portal-comunicacao",
    component: () => import("@/views/contabil/comunicacao/ComunicacaoBase.vue"),
    name: ContabilPortalComunicaoRouter.base
  }
];
